import { render } from "./CaracProduto.vue?vue&type=template&id=b6a25852&scoped=true"
import script from "./CaracProduto.vue?vue&type=script&lang=js"
export * from "./CaracProduto.vue?vue&type=script&lang=js"

import "./CaracProduto.vue?vue&type=style&index=0&id=b6a25852&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a25852"]])

export default __exports__